import { render, staticRenderFns } from "./AddTip.vue?vue&type=template&id=c55c0828&"
import script from "./AddTip.vue?vue&type=script&lang=js&"
export * from "./AddTip.vue?vue&type=script&lang=js&"
import style0 from "./AddTip.vue?vue&type=style&index=0&id=c55c0828&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports